import { IProject, IProjectType } from '../../../types/record/project';
import {
  IProjectAPIValidationErrorFactory,
  IProjectAPIValidationErrorType,
  ProjectAPIRawSuccessResponseType,
  ProjectAPIRawValidationErrorType
} from '../../types/project/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const IProjectFromAPISuccessResponse = ({
  id,
  name,
  company_id,
  status,
  author,
  approver,
  can_be_deleted,
  created_at,
  updated_at
}: ProjectAPIRawSuccessResponseType): IProjectType =>
  IProject({
    id,
    name,
    companyId: company_id,
    status,
    author,
    approver: approver ?? '',
    canBeDeleted: can_be_deleted,
    dateCreated: new Date(created_at).getTime(),
    dateUpdated: new Date(updated_at).getTime()
  });

export const IProjectAPIValidationError = ({
  name,
  company_id
}: ProjectAPIRawValidationErrorType): IProjectAPIValidationErrorType =>
  IProjectAPIValidationErrorFactory({
    name: nullableToStringList(name),
    companyId: nullableToStringList(company_id)
  });
